import React, {Component, ReactNode} from 'react';
import '../../assets/css/container/login/LoginMain.css';
import SearchBar from "../../component/SearchBar";
import factlogo from "../../assets/image/factweb_logo.png";

interface LoginMainProps {
	children?: ReactNode; // 👈 children 타입을 명시
}

class LoginMain extends Component<LoginMainProps> {

	render() {
		return (
			<div className='loginWrapper'>
				{/*<SearchBar></SearchBar>*/}
				<div className="fact-logo" style={{
					backgroundImage: `url(${factlogo})`,
				}}/>
				{this.props.children}
			</div>
		);
	}
}

export default LoginMain;